import { useEffect, useRef } from "react";

export default function CursorGlow() {
    const ref = useRef(null);

    useEffect(() => {
        let x = window.innerWidth / 2;
        let y = window.innerHeight / 2;
        let tx = x;
        let ty = y;
        let raf;

        const move = (e) => {
            tx = e.clientX;
            ty = e.clientY;
        };
        const loop = () => {
            x += (tx - x) * 0.1;
            y += (ty - y) * 0.1;
            if (ref.current) {
                ref.current.style.transform = `translate(${x - 300}px, ${y - 300}px)`;
            }
            raf = requestAnimationFrame(loop);
        };
        window.addEventListener("mousemove", move);
        raf = requestAnimationFrame(loop);
        return () => {
            window.removeEventListener("mousemove", move);
            cancelAnimationFrame(raf);
        };
    }, []);

    return (
        <div
            ref={ref}
            aria-hidden="true"
            className="pointer-events-none fixed top-0 left-0 z-30 w-[600px] h-[600px] rounded-full opacity-30 mix-blend-screen hidden md:block"
            style={{
                background:
                    "radial-gradient(circle, rgba(56,189,248,0.30) 0%, rgba(56,189,248,0.12) 42%, transparent 70%)",
            }}
        />
    );
}
